import React from "react";
import { H2HPageProps } from "./type";
import { useLazyLoad } from "../../helpers/hooks";
const Comp = React.lazy(() => import("./H2HPage"));

export default (props: H2HPageProps) => useLazyLoad(<Comp {...props} />);
